import { Y } from '@angular/cdk/keycodes';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { Observable, forkJoin, map, catchError } from 'rxjs';
import { LifeCycleModel } from 'src/app/models/common/lifecycle';
import { BackendListModel } from 'src/app/models/common/list.model';
import { LifeCycleMasterModel } from 'src/app/models/lifecyclemaster';
import { ApiRoutes } from 'src/app/services/apiroutes';
import { ContainerMasterApiService } from 'src/app/services/domain_code/container-master-api.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-life-cycle',
  templateUrl: './life-cycle.component.html',
  styleUrls: ['./life-cycle.component.scss']
})
export class LifeCycleComponent implements OnInit {
  location_url = ApiRoutes.Location;
  company_url = `${ApiRoutes.Company}company/`;
  base_url = environment.baseApiUrl;
  pageLength = 0;
  pageSize = 10;
  pageIndex = 0;
  currentDate = new Date();
  errorObj: any = {}

  @Input()
  isEditable: boolean = true;

  @Output()
  isEditableChange = new EventEmitter<boolean>();

  @Output()
  lifeCycleCount = new EventEmitter<number>();
  @Input()
  containerObj:any;

  lifeCycleForm: FormGroup;
  update: boolean = false;
  loading: boolean = true;
  containerId: any;
  displayedColumns: string[] = ['request_number', 'current_location', 'activity_date','allocation_details', 'status','updated_by'];

  lifycycleList: MatTableDataSource<any>;
  // containerList: MatTableDataSource<any>;
  isEditableForm: boolean = false;
  isShownTable: boolean = true;
  constructor(public lifeCycleService: ContainerMasterApiService, private formBuilder: FormBuilder, private route: ActivatedRoute) { }

  ngOnInit() {
    console.log('Received containerObj:', this.containerObj);

    this.lifeCycleForm = this.formBuilder.group({
      remarks: [null],
      // reminder_date: [null],
      activity_date: [null],
      status: [null],
      current_location: [null],
      blocked_for_company: [null],
      is_temporary_allocation: [null],
      ownership:[null]
    });

    this.route.queryParams.subscribe(params => {
      if ('id' in params) {
        this.containerId = params['id'];
        this.initialData(params['id'])
      }
    });
  }

  containerLifeCycle: BackendListModel<LifeCycleModel>;
  // lifeCycleMasterList!: BackendListModel<LifeCycleMasterModel>;
  lifeCycleMasterList!: LifeCycleMasterModel | any;

  lifeCycleComments: any;
  last_activity_date;

  initialData(id) {
    // this.getLifeCycleList(id);
    // this.getLifeCycleMasterData(id);
    this.refreshLifecycleList(id);
    this.lifeCycleForm.value.current_location = this.containerObj.current_location;
  }

  // Get life cycle list to display as comments
  getLifeCycleList(id) {
    this.lifeCycleService.getLifeCycleListData(id).subscribe({
      next: response => {
        this.lifeCycleCount.emit(response.count)
        this.containerLifeCycle = response;
        this.lifeCycleComments = this.containerLifeCycle;
        this.last_activity_date = this.lifeCycleComments.results[0]?.activity_date
      },
      error: error => {
        console.log("life cycle list", error);
        return error;
      }
    });
  }

  // Get Life cycle status (to Display Chip name in UI)
  getLifeCycleMasterData(container_id, pageSize = 50) {
    pageSize = pageSize || this.pageSize;
    this.lifeCycleService.getLifeCycleMasterDetails(container_id).subscribe({
      next: response => {
        // const lifeCycleMasterList = response;
        if (this.lifeCycleService.latestBlockForCompany.is_temporary_allocation !== null) {
          this.lifeCycleMasterList = response.results.filter(item => item.dev_code !== "blocked");
        }
        else{
          this.lifeCycleMasterList = response.results;
        }
      },
      error: error => {
        console.log("life cycle data", error);
        return error;
      }
    });
  }

  // getContainerLifeCycleById(id) {
  //   this.lifeCycleService.getAllNewContainerLifecycleList(id).subscribe({
  //     next: response => {
  //       this.containerList = new MatTableDataSource(response.results);

  //     }
  //   });
  // }

  // Patch Life cycle Status to form
  lifeCycleMasterChipValue(lifeStatus) {
    this.lifeCycleForm.patchValue({ status: lifeStatus.id, remarks: lifeStatus.name });
  }

  // Post Life cycle data
  postLifeCycle() {
    let payload = this.filterContainerData();
    if (new Date(payload.activity_date) >= new Date(this.getMinDate().activity_date)) {
      if (new Date(payload.activity_date) <= this.currentDate) {
        this.route.queryParams.subscribe(params => {
          if ('id' in params) {
            payload['current_location'] = this.containerObj?.current_location.id;
            this.postLifeCycleMethod(params.id, payload)
          }
        });
      } else {
        this.errorObj = { activity_date: ["Invalid Activity Date, selected date should not be a future date"] };
      }
    } else {
      if (payload.activity_date == null) {
        this.errorObj = { activity_date: ["This field may not be null."] }
      } else {
        this.errorObj = { activity_date: ["Invalid Activity Date, selected date should be after previous activity date"] };
      }
    }
  }

  // Post method
  postLifeCycleMethod(id, data) {
    if (data.blocked_for_company != null) {
      data['is_temporary_allocation'] = false;
    }
    data['ownership'] = this.lifycycleList.data[0].ownership;

    this.lifeCycleService.postLifeCycleList(id, data).subscribe({
      next: response => {
        // this.lifeCycleComments.results = [response, ...this.lifeCycleComments.results];
        this.lifeCycleForm.reset();
        this.isEditableChange.emit(!this.isEditable);
        this.initialData(id);
        this.isShownTable = true;
        // this.isEditableForm = false;
      }, error: error => {
        console.log("lifecycle error", error);
        this.errorObj = { ...error.error }
        return error;
      }
    })
  }

  keysToTransform = [
    // 'current_location',
    'blocked_for_company'
  ];

  filterContainerData() {
    let data = this.lifeCycleForm.value
    for (const key of this.keysToTransform) {
      if (data[key] != null && data[key] != '')
        data[key] = data[key].id;
    }
    return data;
  }

  getMinDate() {
    return this.lifycycleList.data.reduce((prev, curr) => {
      if (prev.activity_date > curr.activity_date) {
        return prev;
      }
      return curr;
    })
  }
  refreshLifecycleList(containerId, pageSize = null, pageIndex = null, searchTerm = '', ordering = '') {
    pageSize = pageSize || this.pageSize;
    pageIndex = pageIndex || this.pageIndex
    this.lifeCycleService.getAllNewContainerLifecycleList(containerId, pageSize, pageIndex + 1, searchTerm, ordering).subscribe({
      next: response => {
        this.lifeCycleService.latestBlockForCompany = response.results[0];
        this.lifycycleList = new MatTableDataSource(response.results.filter((item:any)=>item.is_temporary_allocation!=true));
        this.getLifeCycleMasterData(containerId);

        this.pageLength = response.count;
        if (response.results.length) {
          this.isShownTable = true;
          this.isEditableForm = false;
        }
        this.loading = false;
        this.update = false;
      }
    })
  }

  /** Announce the change in sort state for assistive technology. */
  announceSortChange(sortState: Sort) {
    this.update = true;
    switch (sortState.direction) {
      case 'asc':
        this.refreshLifecycleList(this.pageSize, this.pageIndex, '', sortState.active);
        break;

      case 'desc':
        this.refreshLifecycleList(this.pageSize, this.pageIndex, '', `-${sortState.active}`);
        break;

      default:
        this.refreshLifecycleList(this.pageSize, this.pageIndex);
    }
  }
  pageChanged(event: PageEvent) {
    this.update = true;
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.refreshLifecycleList(this.containerId);
  }
  addLifeCycle() {
    // this.isEditableForm = true;
    this.isShownTable = false;
  }
  backToList() {
    // this.isEditableForm = false;
    this.isShownTable = true;
  }
  redirectToRequest(request) {
    window.open(`/requests/request-processing/request-details?id=${request?.id}&type=${request?.transaction_type}&rtype=${request?.request_type?.dev_name}`, '_blank');
}
}
